import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BuildingOffice2Icon, UserGroupIcon } from '@heroicons/react/24/outline';

import { OPERATOR_COMPANIES_PATH, OPERATOR_OPERATORS_PATH } from 'router/pathName';

/**
 * YAC-2026-009 PR5a・PR5b。運営のダッシュボード。会社の管理と運営の管理の画面へ行く入口だけを置く。
 * サーバーへの要求はしない（会社の情報を読まない。枠のプロフィールだけを読む）。
 */
const OperatorDashboard: React.FC = () => {
  const { t } = useTranslation('layout');
  const cards = [
    {
      id: 'operator-companies-card',
      to: OPERATOR_COMPANIES_PATH,
      title: t('operator.companies'),
      lead: t('operator.dashboard-companies-lead'),
      icon: BuildingOffice2Icon,
    },
    {
      id: 'operator-operators-card',
      to: OPERATOR_OPERATORS_PATH,
      title: t('operator.operators-menu'),
      lead: t('operator.dashboard-operators-lead'),
      icon: UserGroupIcon,
    },
  ];
  return (
    <div className="p-8 flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-h5 font-bold text-neutral/300">{t('operator.dashboard')}</h1>
        <p className="text-body-1 text-neutral/300">{t('operator.lead')}</p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {cards.map(({ id, to, title, lead, icon: Icon }) => (
          <section key={id} aria-labelledby={id} className="bg-white rounded-lg p-6 flex flex-col gap-3">
            <h2 id={id} className="flex items-center gap-2 text-title font-bold text-neutral/300">
              <Icon className="w-6 h-6 text-primary/300" aria-hidden="true" />
              {title}
            </h2>
            <p className="text-body-2 text-neutral/300">{lead}</p>
            <Link to={to} className="self-start text-primary/300 underline">
              {t('operator.open', { name: title })}
            </Link>
          </section>
        ))}
      </div>
    </div>
  );
};

export default OperatorDashboard;
